export default class Tools {
    constructor(state) {
        this.state = state;
    }

    start() {
        let isPenDrawing = false;
        this.shortcutKeyTool();

        document
            .querySelector(`[data-tool="${this.state.curentTool}"]`)
            .classList.add('activ-tool');

        const canvas = document.querySelector('.main-canvas');
        const context = canvas.getContext('2d');

        const curentColorInput = document.getElementById('color-input');
        const prevColorMark = document.getElementById('prev-color-mark');
        prevColorMark.style.backgroundColor = this.state.prevColor;

        const tool = document.querySelector('.tools');
        const palette = document.querySelector('.palette');

        const canvasCurPosition = document.querySelector('.canvas-current-position');

        context.fillStyle = this.state.curentColor;
        context.strokeStyle = this.state.curentColor;
        curentColorInput.value = this.state.curentColor;

        let startX = 0; // coordinates start point to draw
        let startY = 0;
        const img = new Image();
        // draw
        canvas.addEventListener('mousedown', e => {
            context.fillStyle = this.state.curentColor;
            isPenDrawing = true;
            const x = e.offsetX - 1;
            const y = e.offsetY - 1;

            switch (this.state.curentTool) {
                case 'pen': {
                    context.fillRect(x, y, 1, 1);
                    break;
                }
                case 'eraser': {
                    context.clearRect(x, y, 1, 1);
                    break;
                }
                case 'color-picker': {
                    const pixel = context.getImageData(x, y, 1, 1);
                    if (pixel.data[3] / 255 !== 0) {
                        let r = (+pixel.data[0]).toString(16);
                        let g = (+pixel.data[1]).toString(16);
                        let b = (+pixel.data[2]).toString(16);
                        if (r.length === 1) r = `0${r}`;
                        if (g.length === 1) g = `0${g}`;
                        if (b.length === 1) b = `0${b}`;
                        this.state.prevColor = this.state.curentColor;
                        this.state.curentColor = `#${r}${g}${b}`;
                        curentColorInput.value = this.state.curentColor;
                        prevColorMark.style.backgroundColor = this.state.prevColor;
                        context.fillStyle = this.state.curentColor;
                        context.strokeStyle = this.state.curentColor;
                    }
                    break;
                }
                case 'lighten': {
                    Tools.lighten(e, context, x, y);
                    break;
                }
                case 'vertical-mirror': {
                    context.fillRect(x, y, 1, 1);
                    context.fillRect(canvas.width - x - 1, y, 1, 1);
                    break;
                }
                case 'rectangle': {
                    startX = x;
                    startY = y;
                    const index = document
                        .querySelector('.activ-layer')
                        .getAttribute('data-layer-num');
                    img.src = this.state.frames[index].slice(5, -2);
                    break;
                }
                default: // do nothing
            }
        });

        canvas.addEventListener('mousemove', e => {
            const x = e.offsetX - 1;
            const y = e.offsetY - 1;
            if (isPenDrawing) {
                switch (this.state.curentTool) {
                    case 'pen': {
                        context.fillRect(x, y, 1, 1);
                        break;
                    }
                    case 'eraser': {
                        context.clearRect(x, y, 1, 1);
                        break;
                    }
                    case 'vertical-mirror': {
                        context.fillRect(x, y, 1, 1);
                        context.fillRect(canvas.width - x - 1, y, 1, 1);
                        break;
                    }
                    case 'rectangle': {
                        context.clearRect(0, 0, 32, 32);
                        context.drawImage(img, 0, 0);
                        if (startX > x && startY > y) {
                            context.fillRect(startX, startY + 1, 1, y - startY - 1);
                            context.fillRect(startX + 1, startY, x - startX - 1, 1);
                            context.fillRect(x, startY + 1, 1, y - startY - 1);
                            context.fillRect(startX + 1, y, x - startX - 1, 1);
                        } else {
                            context.fillRect(startX, startY, 1, y - startY + 1);
                            context.fillRect(startX, startY, x - startX + 1, 1);
                            context.fillRect(x, startY, 1, y - startY + 1);
                            context.fillRect(startX, y, x - startX + 1, 1);
                        }
                        break;
                    }
                    case 'lighten': {
                        Tools.lighten(e, context, x, y);
                        break;
                    }
                    default: // do nothing
                }
            }
            canvasCurPosition.innerHTML = `${x + 1} : ${y + 1}`;
        });

        const endDraw = () => {
            isPenDrawing = false;
            const index = document.querySelector('.activ-layer').getAttribute('data-layer-num');
            const url = `url('${canvas.toDataURL()}')`;
            document.querySelector('.activ-layer').style.backgroundImage = url;
            this.state.frames[index] = url;
        };

        canvas.addEventListener('mouseup', () => {
            endDraw();
        });

        canvas.addEventListener('mouseout', () => {
            endDraw();
        });

        // change tool
        tool.addEventListener('click', e => {
            if (!e.target.classList.contains('disable-tool')) {
                this.state.curentTool = e.target.closest('.tools__item').getAttribute('data-tool');
                document.querySelector('.activ-tool').classList.toggle('activ-tool');
                e.target.closest('.tools__item').classList.toggle('activ-tool');
            }
        });

        // work with color
        function RGBToHex(rgb) {
            const sep = rgb.indexOf(',') > -1 ? ',' : ' ';
            const color = rgb
                .substr(4)
                .split(')')[0]
                .split(sep);

            let r = (+color[0]).toString(16);
            let g = (+color[1]).toString(16);
            let b = (+color[2]).toString(16);

            if (r.length === 1) r = `0${r}`;
            if (g.length === 1) g = `0${g}`;
            if (b.length === 1) b = `0${b}`;

            return `#${r}${g}${b}`;
        }

        //  color selection from palette
        palette.addEventListener('click', e => {
            if (e.target.matches('.palette-color')) {
                this.state.prevColor = this.state.curentColor;
                this.state.curentColor = RGBToHex(getComputedStyle(e.target).backgroundColor);

                curentColorInput.value = this.state.curentColor;
                prevColorMark.style.backgroundColor = this.state.prevColor;

                context.fillStyle = this.state.curentColor;
                context.strokeStyle = this.state.curentColor;
            }
        });

        //  color selection from input type=color
        curentColorInput.addEventListener(
            'change',
            e => {
                this.state.prevColor = this.state.curentColor;
                prevColorMark.style.backgroundColor = this.state.prevColor;
                this.state.curentColor = e.target.value;
                context.fillStyle = this.state.curentColor;
                context.strokeStyle = this.state.curentColor;
            },
            false
        );
    }

    static shadeColor(pixel, percent) {
        let R = parseInt(pixel.data[0], 10);
        let G = parseInt(pixel.data[1], 10);
        let B = parseInt(pixel.data[2], 10);

        R = parseInt((R * (100 + percent)) / 100, 10);
        G = parseInt((G * (100 + percent)) / 100, 10);
        B = parseInt((B * (100 + percent)) / 100, 10);

        R = R < 255 ? R : 255;
        G = G < 255 ? G : 255;
        B = B < 255 ? B : 255;

        const RR = R.toString(16).length === 1 ? `0${R.toString(16)}` : R.toString(16);
        const GG = G.toString(16).length === 1 ? `0${G.toString(16)}` : G.toString(16);
        const BB = B.toString(16).length === 1 ? `0${B.toString(16)}` : B.toString(16);

        return `#${RR}${GG}${BB}`;
    }

    static lighten(event, context, x, y) {
        const pixel = context.getImageData(x, y, 1, 1);
        if (pixel.data[3] / 255 !== 0) {
            setTimeout(() => {
                if (event.ctrlKey) {
                    // eslint-disable-next-line no-param-reassign
                    context.fillStyle = Tools.shadeColor(pixel, -30);
                } else {
                    // eslint-disable-next-line no-param-reassign
                    context.fillStyle = Tools.shadeColor(pixel, 30);
                }
                context.fillRect(x, y, 1, 1);
            }, 100);
        }
    }

    static shortcutChangeTool(self, name) {
        if (!document.querySelector(`[data-tool="${name}"]`).classList.contains('disable-tool')) {
            // eslint-disable-next-line no-param-reassign
            self.state.curentTool = name;
            document.querySelector('.activ-tool').classList.toggle('activ-tool');
            document
                .querySelector(`[data-tool="${self.state.curentTool}"]`)
                .classList.toggle('activ-tool');
        }
    }

    shortcutKeyTool() {
        window.addEventListener('keyup', e => {
            switch (e.code) {
                case this.state.shortcut.pen: {
                    Tools.shortcutChangeTool(this, 'pen');
                    break;
                }
                case this.state.shortcut.eraser: {
                    Tools.shortcutChangeTool(this, 'eraser');
                    break;
                }
                case this.state.shortcut.verticalMirror: {
                    Tools.shortcutChangeTool(this, 'vertical-mirror');
                    break;
                }
                case this.state.shortcut.colorPicker: {
                    Tools.shortcutChangeTool(this, 'color-picker');
                    break;
                }
                case this.state.shortcut.rectangle: {
                    Tools.shortcutChangeTool(this, 'rectangle');
                    break;
                }
                case this.state.shortcut.paintBucket: {
                    Tools.shortcutChangeTool(this, 'paint-bucket');
                    break;
                }
                case this.state.shortcut.lighten: {
                    Tools.shortcutChangeTool(this, 'lighten');
                    break;
                }
                default: // do nothing
            }
        });
    }
}
